import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23')
];

export const server_loads = [0,2,5,4];

export const dictionary = {
		"/": [~6],
		"/SogenactifCw/process/[type]": [7],
		"/adyen/index/sessionReturn": [9],
		"/cart": [10],
		"/checkout": [11,[2]],
		"/checkout/onepage/fail": [12,[2]],
		"/checkout/onepage/success": [13,[2]],
		"/contact_form": [14],
		"/customer/account/create": [17,[3,5]],
		"/customer/account/forgotpassword": [18,[3,5]],
		"/customer/account/login": [19,[3,5]],
		"/customer/account/resetpassword": [20,[3,5]],
		"/customer/(loggedin)/order": [15,[3,4]],
		"/customer/(loggedin)/order/[id]": [16,[3,4]],
		"/newsletter/subscription/[type]": [21],
		"/sales/guest/form": [22],
		"/sales/guest/view": [23],
		"/[...slug]": [8]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';